import loadScript from '../util/loader';
import isTouch from '../util/touch';

const defaultOptions = {
  autoplay: true,
  loop: true,
  controls: true,
  muted: false,
  playsinline: true,
};

export default function embedVimeo(uniqueKey, options) {
  const playerOptions = {
    ...defaultOptions,
    ...options,
  };
  const playerWrapper = document.querySelector(`[data-player="${uniqueKey}"]`);
  const playerElement = playerWrapper.querySelector('iframe, [data-replace]');
  const vimeoKey = playerWrapper.querySelector('[data-video-id]').getAttribute('data-video-id');
  const loadedPromise = loadScript({url: 'https://player.vimeo.com/api/player.js'});
  const vimeoSelector = `select-${uniqueKey}`;
  playerElement.setAttribute('id', vimeoSelector);
  const returnPlayer = loadedPromise
    .then(function () {
      const player = new window.Vimeo.Player(vimeoSelector, {
        ...playerOptions,
        id: vimeoKey,
      });
      playerWrapper.addEventListener('pause', function () {
        try {
          if (player.pause) {
            player.pause();
          }
        } catch (e) {
          console.warn(e);
        }
      });
      playerWrapper.addEventListener('play-desktop', function () {
        if (!isTouch()) {
          playerWrapper.dispatchEvent(new Event('play'));
        }
      });
      playerWrapper.addEventListener('play', function () {
        if (player.play) {
          player.play();
        }
      });
      playerWrapper.addEventListener('destroy', function () {
        try {
          if (player.destroy) {
            player.destroy();
          }
        } catch (e) {
          console.log(e);
        }
      });
      return player;
    })
    .catch(function (err) {
      console.error(err);
    });
  return returnPlayer;
}
